export default {
  pageTitle: 'Portofolio',
  metaDescription: 'Lihat portofolio proyek TEF berdasarkan produk, material, dan negara tujuan, menampilkan ribuan pressure vessel dan heat exchanger yang telah dikirim ke seluruh dunia.',
  hero: { title: 'Portofolio' },
  section: {
    heading: 'Portofolio',
    experiencedTitle: 'PENGALAMAN MATERIAL & PERALATAN',
    achievements: {
      title: 'PENCAPAIAN (1998 – SEP 2024)',
      projectsSuffix: 'PROYEK',
      exportedPrefix: 'DIEKSPOR KE',
      countriesSuffix: 'NEGARA',
      fabricationPrefix: 'FABRIKASI LEBIH DARI',
      typeOfMaterialsSuffix: 'JENIS MATERIAL',
      customersPrefix: 'LEBIH DARI',
      customersSuffix: 'PELANGGAN',
      plantsSuffix: 'PABRIK',
    },
    materialCategories: {
      title: 'KATEGORI MATERIAL',
      examplePrefix: 'cth.',
      niBaseAlloy: 'PADUAN BERBASIS NIKEL',
      titaniumZirconium: 'TITANIUM & ZIRCONIUM',
      duplexSteel: 'BAJA DUPLEX',
      austeniticSS: 'STAINLESS STEEL AUSTENITIK',
      others: { name: 'LAINNYA', example: 'Tembaga-Nikel, Baja Karbon' },
    },
    applicationAreas: {
      title: 'AREA APLIKASI',
      towerColumn: 'TOWER/KOLOM',
      vesselReactor: 'VESSEL/REAKTOR',
      heatExchanger: 'HEAT EXCHANGER',
      piping: 'PERPIPAAN',
      muffle: 'MUFFLE',
      radiantTube: 'RADIANT TUBE',
      others: 'LAINNYA',
    },
  },
  dashboard: {
    heading: 'Portofolio',
    subheading: 'REKAP PENGIRIMAN DARI 1998 - JULI 2024',
    byProduct: 'BERDASARKAN PRODUK',
    byMaterial: 'BERDASARKAN MATERIAL',
    byCountry: 'BERDASARKAN NEGARA',
  },
};
